import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import s1 from "../../assets/images/smg1.png";
import s2 from "../../assets/images/smg2.png";
import s3 from "../../assets/images/smg3.png";
import s4 from "../../assets/images/smg4.png";
import s5 from "../../assets/images/smg5.png";
import s6 from "../../assets/images/smg6.png";

const SocialMediaGrowthSection = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-4 sm:px-8 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <section className="py-3 md:py-16 max-w-[1536px] mx-auto transition-all duration-500">
        {/* Heading */}
        <div className="text-center mb-4 md:mb-12">
          <h2
            className={`text-2xl bricolage-grotesque-bold sm:text-3xl md:text-5xl font-bold mb-3 sm:mb-4 transition-all duration-500 ${
              theme === "dark" ? "text-black" : "text-white"
            }`}
          >
            Social Media Growth
          </h2>

          <span
            className={`inline-block bricolage-grotesque-semibold text-xs sm:text-sm md:text-base px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 rounded-full tracking-widest border transition-all duration-500 ${
              theme === "dark"
                ? "bg-white text-black border-gray-300"
                : "bg-[#111111] text-white border-[#2a2a2a]"
            }`}
          >
            LINKEDIN
          </span>
        </div>

        {/* Images Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div className="overflow-hidden shadow-sm border h-[250px] sm:h-[300px] md:h-[400px] group transition-all duration-500">
            <img
              src={s1}
              alt="LinkedIn analytics 1"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>

          <div className="overflow-hidden shadow-sm border h-[180px] sm:h-[220px] md:h-[200px] group transition-all duration-500">
            <img
              src={s2}
              alt="LinkedIn analytics 2"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>

          <div className="overflow-hidden shadow-sm border h-[250px] sm:h-[300px] md:h-[400px] group transition-all duration-500">
            <img
              src={s3}
              alt="LinkedIn analytics 3"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>

          <div className="overflow-hidden shadow-sm border h-[250px] sm:h-[300px] md:h-[400px] md:-my-48 group transition-all duration-500">
            <img
              src={s4}
              alt="LinkedIn analytics 4"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>

          <div className="overflow-hidden shadow-sm border h-[180px] sm:h-[200px] md:h-[200px] my-1 sm:my-2 group transition-all duration-500">
            <img
              src={s5}
              alt="LinkedIn analytics 5"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>

          <div className="overflow-hidden shadow-sm border h-[250px] sm:h-[300px] md:h-[400px] md:-my-48 group transition-all duration-500">
            <img
              src={s6}
              alt="LinkedIn analytics 6"
              className="w-full h-full object-cover object-top transition-transform duration-500 ease-in-out group-hover:scale-105"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default SocialMediaGrowthSection;
